<script type="text/javascript">
    import { defineAsyncComponent } from 'vue';

    export default {
        Accordion: defineAsyncComponent(() => import(/* webpackChunkName: "ui-accordion" */'@/components/UI/Accordion/Accordion.vue')),
        AccordionItem: defineAsyncComponent(() => import(/* webpackChunkName: "ui-accordion" */'@/components/UI/Accordion/Item.vue')),
    }
</script>